import { Paper, Stack, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useTranslationHook } from "../../hooks/UseTranslationHook";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { GlobalVariables } from "../../globalVar";
import customAxios from "../../utils/customAxios";

function VTypesDetailPanel({ row: rowProp }) {
  const [vTypesDetailData, setVTypesDetailData] = useState([]);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);


  const {
    questionnarieQNameString,
    questionnarieQDescriptionString,
    noQuestionnariesString,
  } = useTranslationHook();

  useEffect(() => {
    const updatedVTypesDetailData = () => {
      setVTypesDetailData((prevData) => {
        return prevData.map((detail) => ({
          ...detail,
        }));
      });
    };
    i18next.on('languageChanged', updatedVTypesDetailData);

    return () => {
      i18next.off('languageChanged', updatedVTypesDetailData);
    };
  }, [t]);

  const endpoint = `${GlobalVariables.getURL()}listVisitTypes`

  const getData = async () => {
    setIsLoading(true);

    try {
        const response = await customAxios.get(endpoint, { 
          params: {visitTypeId: rowProp.id },
          headers: {
            'Authorization': 'bearer ' + localStorage.getItem('token')
          }  
        });
        const vTypesDetailData = response.data.map((detail) => {
            return {
                ...detail,
            }
        });
        setVTypesDetailData(vTypesDetailData);
        setIsLoading(false);
    } catch (error) {
        console.log(error);
        setIsLoading(false);
    }
  };

  useEffect(() => {
      getData();
  }, []);

  useEffect(() => {
      // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  const gridHeight = Math.min(200, 100 + vTypesDetailData.length * 50);

    return (
      <Stack
        sx={{ py: 2, boxSizing: 'border-box',  height: `${gridHeight} px` }}
        direction="column"
      >
        <Paper sx={{ flex: 1, mx: 'auto', width: '90%', p: 1, height: '100%' }}>
          <Stack direction="column" spacing={1} sx={{ height: '100%' }}>
            <Typography variant="h6">{`#${rowProp.id} | ${rowProp.vt_name}`}</Typography>
            <DataGridPro
              density="compact"
              columns={[
                {
                    field: 'id',
                    headerName: 'ID',
                    width: 70
                },
                { 
                    field: 'name', 
                    headerName: questionnarieQNameString,
                    width: 200,
                },
                {
                    field: 'description',
                    headerName: questionnarieQDescriptionString,
                    align: 'left',
                    width: 400
                }
              ]}
              rows={vTypesDetailData}
              autoHeight
              slots={{
                noRowsOverlay: () => (
                    <Stack height="100%" alignItems="center" justifyContent="center">
                        {noQuestionnariesString}
                    </Stack>
                )
              }}
              hideFooter 
            />
          </Stack>
        </Paper>
      </Stack>
    );
}

export default VTypesDetailPanel;